/** @jsx $jsx */
import { $jsx } from 'framework7';
import { setup } from '../../js/sandbox_scripts/distanceSensor.js';
export default (function (props, _ref) {
  var $f7 = _ref.$f7,
      $on = _ref.$on;
  $on('pageMounted', function () {
    // $('.btn').prop('disabled', false);
    setup();
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
    <div class="page" data-name="distanceSensor">
   <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner sliding">
         <div class="title">Distance Sensor</div>
      </div>
   </div>
   <div class="page-content">
      <div class="container pt-2">
         <h3>Distance Sensor</h3>
         <div class="block-title">Control</div>
         <div class="card p-2">
            <div class="row">
               <div class="col-md-8">
                  <div class="list inline-labels no-hairlines-md">
                     <ul>
                         <li>
                            <div class="item-content item-input">
                                <div class="item-inner">
                                    <div class="item-title item-label"> Robot ID </div>
                                    <div class="item-input-wrap"> <input type="number" id="distance-sensor-robot-id" min="0" value="0"/> </div>
                                </div>
                            </div>
                         </li>
                         <li>
                            <div class="item-content item-input">
                                <div class="item-inner">
                                    <div class="item-title item-label"> Reality </div>
                                    <div class="item-input-wrap input-dropdown-wrap" >
                                       <select id="dist-sensor-robot-reality" class="" >
                                          <option value="V"> Virtual </option>
                                          <option value="R"> Real </option>
                                          <option value="M"> Both </option>
                                       </select>
                                    </div>
                                </div>
                            </div>
                         </li>
                        <li>
                           <div class="item-content item-input">
                               <div class="item-inner">
                                  <div class="item-title item-label"> Distance </div>
                                  <div class="item-input-wrap">
                                     <div class="range-slider range-slider-init" data-label="true" > <input id="distance-sensor-dist-bar" type="range" min="0" max="300" step="1" value="0"/> </div>
                                     <input type="number" id="dist-val" min="0" max="300" value="0"/>
                                  </div>
                               </div>
                           </div>
                        </li>
                     </ul>
                  </div>
               </div>
               <div class="col-md-4">
                  <div class="p-2"> <b ><span class="channel">{channel}</span >/sensor/distance/<span class="distance-sensor-robot-id" >{robotId}</span >/?</b > <span class="float-right"> <a target="_blank" class="link external" href="https://pera-swarm.ce.pdn.ac.lk/docs/communication/mqtt/sensor#sensordistancerobotid" >[?]</a > </span> <button class="col button button-raised button-fill color-grey" id="dist-btn-req" > Req from Robot </button> </div>
                  <div class="p-2">
                     <b ><span class="channel">{channel}</span >/sensor/distance/<span class="distance-sensor-robot-id" >{robotId}</span ></b > <span class="float-right"> <a target="_blank" class="link external" href="https://pera-swarm.ce.pdn.ac.lk/docs/communication/mqtt/sensor#sensordistancerobotid-1" >[?]</a > </span>
                     <div> <span class="dist-val">0</span> </div>
                     <button class="col button button-raised button-fill color-blue" id="dist-btn-send-robot" > Send to Robot </button>
                  </div>
                  <div class="p-2">
                     <b ><span class="channel">{channel}</span >/sensor/distance/</b > <span class="float-right" ><a target="_blank" class="link external" href="https://pera-swarm.ce.pdn.ac.lk/docs/communication/mqtt/sensor#sensordistance" >[?]</a ></span >
                     <div>{"id":"<span class="distance-sensor-robot-id" >{robotId}</span >", "dist":"<span class="dist-val">0</span>", "reality":"<span class="dist-reality-label">V</span>" }</div>
                     <button class="col button button-raised button-fill color-green" id="dist-btn-send-server" > Send to Server </button> <br/>
                  </div>
               </div>
            </div>
         </div>
         <div class="block-title">Responses</div>
         <div class="card p-3 list no-hairlines-md">
            <ul>
               <li class="item-content item-input">
                  <div class="item-inner">
                     <div class="item-title item-label"> Request received by the simulator (<b ><span class="channel">{channel}</span >/sensor/distance</b >)<br/> </div>
                     <div class="item-input-wrap"> <textarea id="dist-sub-text" class="resizable" ></textarea> <span class="input-clear-button"></span> </div>
                  </div>
               </li>
               <li class="item-content item-input">
                  <div class="item-inner">
                     <div class="item-title item-label"> Distance reading sent to the robot (<b ><span class="channel">{channel}</span >/sensor/distance/<span class="distance-sensor-robot-id" >{robotId}</span ></b >)<br/> </div>
                     <div class="item-input-wrap"> <textarea id="dist-robot-text" class="resizable" ></textarea> <span class="input-clear-button"></span> </div>
                  </div>
               </li>
            </ul>
         </div>
      </div>
   </div>
</div>
`
    }
    ;
});